import React, { useState, useEffect, lazy, Suspense } from "react";
import "./technician.css";
import { HeadersCentral } from "../../layouts/headers-central/headers-central";
import { MainContent } from "../../layouts/MainContent";
import { Headers } from "../../layouts/headers/headers";
import TechnicianFilter from "../../components/filters/filterTechnician";
import { getAllTechnicians } from "../../interpreter/technician";
import { TechnicianList } from "../../components/datatable/TechnicianList";

// ✅ Lazy load de modales para optimizar el bundle
const UserModal = lazy(() => import("../../components/modals/profileUser"));
const ResetPasswordModal = lazy(() => import("../../components/modals/resetPassword"));
const ResetDataTechnician = lazy(() => import("../../components/modals/resetDataTechnician"));
const RecordSubcriptionTechnician = lazy(() => import("../../components/modals/recordSubcriptionTechnician"));
const ResetSubcription = lazy(() => import("../../components/modals/resetSubcription"));

const Technician = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [technicians, setTechnicians] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTechnician, setSelectedTechnician] = useState(null);
  const [activeModal, setActiveModal] = useState(null); // 'reset', 'subscription', 'history', 'data', null

  const fetchTechnicians = async () => {
    setLoading(true);
    try {
      const data = await getAllTechnicians();
      setTechnicians(Array.isArray(data?.technicians) ? data.technicians : []);
    } catch (error) {
      console.error("Error al obtener técnicos:", error);
      setTechnicians([]);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchTechnicians();
  }, []);

  // ✅ Función para abrir modales
  const openModal = (modalType, technician) => {
    setSelectedTechnician(technician);
    setActiveModal(modalType);
  };

  // ✅ Función para cerrar modales
  const closeModal = () => {
    setActiveModal(null);
    setSelectedTechnician(null);
  };

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Headers />

      {/* Main Content */}
      <MainContent>
        <HeadersCentral 
            showDropdown={showDropdown}
            setShowDropdown={setShowDropdown}
            openModal={() => openModal('user')}
        />

        <main className="p-6">
          <h1 className="text-3xl font-bold mb-6 flex items-center gap-3 text-gray-800">
            <svg className="w-8 h-8 text-blue-500" fill="currentColor" viewBox="0 0 20 20"><path d="M10 2a8 8 0 00-8 8v4a2 2 0 002 2h2l1 2h6l1-2h2a2 2 0 002-2v-4a8 8 0 00-8-8z" /></svg>
            Panel de Control de Abogados 
          </h1>
          <TechnicianFilter
            setTechnicians={setTechnicians}
            setLoading={setLoading}
            getAllTechnicians={getAllTechnicians}
          />
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <TechnicianList 
              openModal={openModal}  
              technicians={technicians}
              loading={loading}
            />
          </div>
        </main>
      </MainContent>

      {/* ✅ Modales */}
     <Suspense fallback={null}>
        {activeModal === "user" && <UserModal isOpen={true} onClose={closeModal} />}
        {activeModal === "reset" && (
          <ResetPasswordModal
            isOpen={true}
            onClose={closeModal}
            user={selectedTechnician}
            userType="Tecnico"
          />
        )}
        {activeModal === "subscription" && selectedTechnician && (
          <ResetSubcription
            isOpen={true}
            onClose={closeModal}
            technician={selectedTechnician}
            onSuccess={fetchTechnicians}
          />
        )}
        {activeModal === "history" && (
          <RecordSubcriptionTechnician
            isOpen={true}
            onClose={closeModal}
            technicianId={selectedTechnician}
          />
        )}
        {activeModal === "data" && (
          <ResetDataTechnician
            isOpen={true}
            onClose={closeModal}
            technician={selectedTechnician}
          />
        )}
      </Suspense>
    </div>
  );
};

export default Technician;
